import { createSlice } from "@reduxjs/toolkit";
import { FULLFILLED, PAGINATION_DEFAULTS } from "@root/constants";
import {
  DELETE_THREADS,
  GET_PROFILE,
  GET_THREAD_BY_ID,
  GET_THREADS,
} from "@root/store/action-types";
import { groupByDate } from "@root/utils/dateHelper";

interface IInitialValue {
  activeThread: ICurrentChat[];
  threads: any;
  threadId: number;
  data: any;
  selectFilePopup: boolean;
  fileIndex: number;
  popOverIndexType: "inc" | "dec";
  selectedFiles: any[];
  profile: any;
  mode: "chat" | "search";
}
const initialValue: IInitialValue = {
  activeThread: [],
  threads: {},
  threadId: 0,
  data: {
    page: 1,
    pageSize: PAGINATION_DEFAULTS.THREAD_PAGE_SIZE,
    maxSize: 0,
  },
  selectFilePopup: true,
  fileIndex: 1,
  popOverIndexType: "inc",
  selectedFiles: [],
  profile: {},
  mode: "chat",   //default mode is Law
};

export const chatEntitySlice = createSlice({
  name: "chat",
  initialState: initialValue,
  reducers: {
    addThread: (state, action: any) => {
      state.activeThread = [...state.activeThread, action.payload];
    },
    switchChat: (state, action) => {
      state.activeThread = action?.payload;
      state.threadId = 0;
    },
    updateChatActiveChat: (state, action) => {
      state.activeThread = [...state.activeThread, ...action?.payload];
      state.data.pageCount = state.data.pageCount + 1;
      state.data.page = state.data.page + 1;
    },
    updateThreadId: (state, action) => {
      state.threadId = action.payload;
    },
    updateChatPage: (state, action) => {
      state.data.page = action.payload;
    },
    filePopOverHandler: (state, action) => {
      state.selectFilePopup = action.payload;
    },
    updateChatMode: (state, action) => {
      state.mode = action.payload;
    },
    updateFileIndex: (state, action) => {
      state.fileIndex = action.payload;
    },
    updateFileIndexType: (state, action) => {
      state.popOverIndexType = action.payload;
    },
    addSelectedFile: (state, action) => {
      state.selectedFiles = [...state.selectedFiles, action.payload];
    },
    updateSelectedFile: (state, action) => {
      state.selectedFiles = action.payload;
    },
    updateThreads: (state, action) => {
      state.threads = action.payload;
    },
    removesSelectedFile: (state, action) => {
      const filteredPdfs = state?.selectedFiles?.filter(
        (item) => item?.id !== action.payload
      );
      state.selectedFiles = filteredPdfs;
    },
    updateChatById: (state, action) => {
      const { id, key, value } = action?.payload;
      // @ts-ignore
      state.activeThread = state.activeThread.map((thread: any) => {
        if (thread?.id === id) {
          return {
            ...thread,
            [key]: value,
          };
        } else {
          return thread;
        }
      });
    },
    appendChildChat: (state, action) => {
      const { id, chat } = action?.payload;
      const systemChatRef = id + 1;
      // @ts-ignore
      state.activeThread = state.activeThread.map((thread: any) => {
        if (thread?.id === id || systemChatRef === thread?.id) {
          return {
            ...thread,
            childChats: [...thread?.childChats, chat],
          };
        } else {
          return thread;
        }
      });
    },
  },
  extraReducers: (builder) => {
    builder.addCase(`${GET_THREADS}${FULLFILLED}`, (state, action: any) => {
      state.threads = groupByDate(action?.payload?.rows);
      state.data.maxSize = action?.payload?.count;
    });
    builder.addCase(
      `${GET_THREAD_BY_ID}${FULLFILLED}`,
      (state, action: any) => {
        state.data.maxSize = action?.payload?.count;
      }
    );
    builder.addCase(`${DELETE_THREADS}${FULLFILLED}`, (state, action: any) => {
      if (action?.payload?.ids) {
        const filteredT: any[] = [];
        state?.threads?.rows?.forEach((thread: any) => {
          if (!action?.payload?.ids.includes(thread?.id)) {
            filteredT.push(thread);
          }
        });
        state.threads = { ...state.threads, rows: filteredT };
      }
    });
    builder.addCase(`${GET_PROFILE}${FULLFILLED}`, (state, action: any) => {
      state.profile = action?.payload;
    });
  },
});

export const {
  addThread,
  switchChat,
  updateThreadId,
  updateChatActiveChat,
  updateChatPage,
  filePopOverHandler,
  updateChatMode,
  updateFileIndex,
  addSelectedFile,
  updateSelectedFile,
  updateFileIndexType,
  removesSelectedFile,
  updateThreads,
  updateChatById,
  appendChildChat,
} = chatEntitySlice.actions;
export const chatEntityReducer = chatEntitySlice.reducer;
